
/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import EdgeCountrySettingsFields from './EdgeCountrySettingsFields'

const EdgeCountrySettings = (props) => {

  return (
    <MainRouteSubRoutePage mainTitle='routeTitles.edgeCountrySettings'>
      <EdgeCountrySettingsFields />
    </MainRouteSubRoutePage>
  )
}

export default EdgeCountrySettings
